export default "__VITE_ASSET__CJjJbzk8__"